import { TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';
import _ from 'underscore';

import { Messages } from '~src/codegen/Localize';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService,ToastType } from '~src/commonInfra/services/ToasterService';
import { SettingsStyles } from '~src/settings/styles/CommonStyles';

import { IGetDockerRegistryResult } from '../../serverApi/requests/GetDockerRegistryRequest';
import { BaasEdgePool } from '../../serverApi/resources/BaasEdgePool';
import { ActionItemInfo } from '../MoreActionsMenu';
import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';

export type GetDockerRegistryDialogProps = Readonly<{
  isDockerRegistryReady: boolean;
  description: string;
  dockerRegistryURL: string;
  username: string;
  password: string;
}>

export function openGetDockerRegistryDialog(actionItem: ActionItemInfo) {
  const {clusterId, siteId } = actionItem;

  BaasEdgePool.getDockerRegistry({siteId: siteId, clusterId: clusterId})
      .then((result: IGetDockerRegistryResult) => {
        if (result.success) {
          const {dockerRepository, loginName, password} = result.success;
          const dialogInstance = openReactActionDialog({
            title: Messages.dataConnectSiteSettingsGetDockerRegistryButton(),
            bodyComponent: GetDockerRegistryDialogBody,
            initialBodyProps: {
            isDockerRegistryReady: !_.isEmpty(dockerRepository),
            description: _.isEmpty(dockerRepository)? Messages.dataConnectSiteSettingsGetDockerRegistryDescriptionNotReady()
            : Messages.dataConnectSiteSettingsGetDockerRegistryDescription(),
            dockerRegistryURL: Messages.dataConnectSiteSettingsGetDockerRegistryURL({ URL: dockerRepository }),
            username: Messages.dataConnectSiteSettingsGetDockerRegistryUsername({ USERNAME: loginName }),
            password: Messages.dataConnectSiteSettingsGetDockerRegistryPassword({ PASSWORD: password }),
           },
            initialDialogState: { hasError: false },
            actionName: Messages.confirm(),
            action: () => {
              return Promise.resolve({});
            },
            dismissDialogOnActionFailed: true,
            dialogWidth: TabDialogWidth.width375px,
            hideCancelButton: true,
          });
          return Promise.resolve(dialogInstance.result);
        }
        if (result.errors) {
          ToasterService.instance.pop({
            type: ToastType.Error,
            text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
          });
        }
      });
}

export function GetDockerRegistryDialogBody(props: GetDockerRegistryDialogProps) {

  const descriptionDivClassName = `${SettingsStyles.settingsGroupDescription}`;
  const {isDockerRegistryReady} = props;
  return (
    <div className={fieldClass}>
      <div className={descriptionDivClassName}
                data-tb-test-id={'pool-docker-registry-text-details'}>
                <span>
                  {props.description}
                </span>
                {
                isDockerRegistryReady && <>
                <span className={cammandLIneClass}>
                  {props.dockerRegistryURL}
                </span>
                <span className={cammandLIneClass}>
                  {props.username}
                </span>
                <span className={cammandLIneClass}>
                  {props.password}
                </span></>
                }
      </div>
    </div>
  );
}

const fieldClass = style({ marginBottom: TabStyles.Sizing.BaseUnit * 5 });

const cammandLIneClass = style({ marginTop: 10, display: 'block', fontWeight: 'bold' });

export const errorClass = style({ marginTop: TabStyles.Spacing.DefaultSpace, color: TabStyles.Colors.AttentionDark });



